export const NAME_MIN_LENGTH = 2
export const NAME_MAX_LENGTH = 50
export const EMAIL_MAX_LENGTH = 200
export const PASSWORD_MIN_LENGTH = 6
export const PASSWORD_MAX_LENGTH = 20
export const POSITION_MIN_LENGTH = 3
export const PHONE_SMS_CODE_MIN_LENGTH = 5
export const PHONE_CALL_CODE_MIN_LENGTH = 4
export const ORGANIZATION_MIN_LENGTH = 3
export const UNIVERSITY_MIN_LENGTH = 2
export const MINIMAL_AGE = 18
export const MINIMAL_YEAR = 1900

export const LOGON_MAIL_REGEX = /^[a-zA-Zа-яА-Я0-9._%+-]+@[a-zA-Zа-яА-Я0-9.-]+\.[a-zA-Zа-яА-Я]{2,}$/
export const MAIL_REGEX =
  /^(([\w0-9-+!#&$%*/=^?`'{|}~.]+)|(".+"))@([a-zA-Z0-9-]+\.)+((xn--[a-zA-Z0-9]+)|([a-zA-Z]{2,}))$/
export const ACCEPTABLE_PASSWORD_SYMBOLS = 'a-zA-Z0-9-.@'
export const PASSWORD_REGEX = new RegExp(`^([${ACCEPTABLE_PASSWORD_SYMBOLS}]){1,}$`)
export const COMMON_CYRILLIC_ALPHABET = '\\sа-яА-ЯёЁ\\-'
export const UZ_LATIN_ALPHABET = "a-vx-zA-VX-Z‘’ʼʻ'"
